import { ClientCreation } from '@Arti-zen/package-backoffice'
import { Check } from '@mui/icons-material'
import SelectMui from 'components/forms/SelectMui'
import Info from 'components/Info'
import { Row, InfoRedStyle, ValidButton, Error } from 'modules/product/ProductListTable.definitionFields'
import { useState } from 'react'

type TProps = {
  city?: string
  currentPostalCode?: string
  expectedPostalCode: string[]
  correctClient: (corrections: Partial<ClientCreation>) => void
}

export default function PostalCodeErrorTable({ expectedPostalCode, correctClient, city, currentPostalCode }: TProps) {
  const [postalCode, setPostalCode] = useState<string>(expectedPostalCode?.[0] ?? null)
  const items = expectedPostalCode.map((item) => {
    return { value: item, label: item }
  })

  const updatePostalCode = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    correctClient({ postalCode })
  }
  return (
    <>
      <Row style={{ paddingTop: 4, gap: 15 }}>
        <div style={{ position: 'relative' }}>
          <SelectMui items={items} value={postalCode} onChange={(cp) => setPostalCode(cp)} fontSize={10} size="small" />
          <Info
            text={
              currentPostalCode
                ? `Le code postal renseigné "${currentPostalCode}" ne correspond pas à la ville "${city}". Suggestions : ${expectedPostalCode.join(', ')}.`
                : `Le code postal n'est pas renseigné. Suggestions par rapport à la ville : ${expectedPostalCode.join(', ')}.`
            }
            style={{ ...InfoRedStyle, top: -4, right: -10 }}
            absolute
          />
        </div>

        <ValidButton onClick={updatePostalCode} style={{ height: 30, fontSize: 15 }}>
          <Check fontSize="inherit" />
        </ValidButton>
      </Row>
      {currentPostalCode && <Error style={{ margin: 0, fontSize: 12 }}>{currentPostalCode}</Error>}
    </>
  )
}
